import Address from './Address.js'

export default function Entity(submissionId, changeId, isBefore) {
  this.submissionID = submissionId
  this.changeID = changeId
  this.entityID = null
  this.entityTypeID = 0
  this.entityName = ''
  this.fein = ''
  this.phone = ''
  this.address = new Address()
  this.contactName = ''
  this.contactEmail = ''
  this.websiteURL = ''
  this.carrierName = ''
  this.policyNumber = ''
  this.coverageId = ''
  this.effectiveDate = ''
  this.beforeChange = isBefore
  this.isNew = ''
}